<template functional>
  <div role="button" class="load-more-button robotoR" @click="data.on.click">
    <div class="plus-more-text-div"><span class="plus-more-text-span"><slot/></span>
      <span class="blue-triangle"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadMoreButton'
};
</script>

<style>
.load-more-button {
  @apply inline-block align-middle select-none text-center cursor-pointer bg-white;
  border: 1px solid #d3d3d6;
  border-radius: 4px;
  line-height: 1.42857143;
  white-space: nowrap;
  font-size: 12px;
  color: #096dce;
  padding: 7px 9px 6px 10px;
  outline: none !important;

  &:hover {
    color: #0989ff;
    border-color: rgba(9, 147, 255, 0.6);
  }

  &:active {
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .13);
  }

  .plus-more-text-span {
    margin-right: 4px;
  }

  .blue-triangle {
    background: url(~@/assets/images/blue-triangle.png) no-repeat;
    width: 8px;
    height: 6px;
    display: inline-block;
  }
}
</style>